export default __webpack_public_path__ + "static/media/create_profile.7decc056.png";